// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","fundUpdatePressMediaList":"_2br14VQy3s9h_qyCDI1wuh"};